const bom = {
  state: {
    bomId: 0,
    bomName: '',
    bomFatherId: 0,
    bomList: [],
    bomProjects: ''
  },
  getters: {
    bomId: state => state.bomId,
    bomName: state => state.bomName,
    bomFatherId: state => state.bomFatherId,
    bomList: state => state.bomList,
    bomProjects: state => state.bomProjects
  },
  mutations: {
    setBomId: (state, bomId) => {
      state.bomId = bomId
    },
    setBomName: (state, bomName) => {
      state.bomName = bomName
    },
    setBomFatherId: (state, fatherId) => {
      state.bomFatherId = fatherId
    },
    setBomList: (state, bomList) => {
      state.bomList = bomList
    },
    setBomProjects: (state, bomProjects) => {
      state.bomProjects = bomProjects
      console.log(state.bomProjects)
    }
  },
  actions: {
    handleBomList (bomList, data) {
      bomList.commit('setBomList', data)
    }
  }
}
export default bom
